import { render, staticRenderFns } from "./TrainingRequestPage.vue?vue&type=template&id=31b2405a&"
import script from "./TrainingRequestPage.vue?vue&type=script&lang=js&"
export * from "./TrainingRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports